import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// [pk争霸赛规则页奖励](http://wiki.xunlei.cn/pages/viewpage.action?pageId=151086305)
export const competition_rule_list = createAsyncThunk(
  'live/pk/competition_rule_list',
  async (p, store: any) => {
    const resp = await http.post(
      '/live/pk/competition_rule_list',
      {},
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data?.data
  }
)

type RoundReward = {
  url?: string
  desc?: string
}
type BoxItem = {
  box_url?: string // 宝箱大图url
  box_rewards?: Array<RoundReward>
}
type TableItem = {
  score?: string
  coins?: number
  room_frame_reward_desc?: string // 房间框奖励描述
  room_background_reward_desc?: string // 房间背景描述
  box_name?: string // 宝箱类型
}
export type GroupItem = {
  track?: string // 赛道名称
  is_my_track?: boolean // 是否是我的赛道
  win_rewards?: Array<TableItem> // 成功表格对象
  lose_rewards?: Array<TableItem> // 失败表格对象
}
export interface InitialStateType {
  round_rewards?: Array<RoundReward> // 单局奖励
  box_item?: Array<BoxItem> // 宝箱奖励
  group_list?: Array<GroupItem> // 赛道
  rule?: any
}

const initialState: InitialStateType = {}
export const PKRulesSlice = createSlice({
  name: 'PKRules',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(competition_rule_list.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})

export default PKRulesSlice.reducer
